import { getRankImage } from '../../utils/permissions.js';
const isLocalhost = typeof window !== "undefined" && window.location.hostname === "localhost";

export const lectures = "/lib/lectures";
export const docBaseUrl = "/lib/docs/";       /* /lib/docs/  changed to /docs/ for vercel */
export const utilBaseUrl = "/lib/utils/";   

export const levelContentData = [
  {
    rank: getRankImage(1),
    level: 100,
    title: "BEGINNER",
    description: "Start building the foundation of HTML & CSS step by step.",
    packageDescription: "desc.beginner",
    contentItems: [ "b.1", "b.2", "b.3", "b.4" ],
    packageFeatures: ["pf.1","pf.2","pf.3"],

    lectures: [
                { group: 0, list: [ "course.html.111.title",
                                    "course.html.112.title",
                                    "course.html.113.title" ]},
                { group: 1, list: [ "course.html.121.title",
                                    "course.html.122.title",
                                    "course.html.123.title"]},
                { group: 2, list:   [ "course.html.131.title",
                                    "course.html.132.title",
                                    "course.html.133.title" ]},
                { group: 3, list: [ "course.html.141.title",
                                    "course.html.142.title",
                                    "course.html.143.title" ]}
              ],
     
    lectureParagraphKeys: [
                            Array.from({ length: 18 }, (_, i) => `course.html.111.p${i+1}`),
                            Array.from({ length: 18 }, (_, i) => `course.html.112.p${i+1}`),                 
                            Array.from({ length: 19 }, (_, i) => `course.html.113.p${i+1}`),
                            Array.from({ length: 19 }, (_, i) => `course.html.121.p${i+1}`),
                            Array.from({ length: 19 }, (_, i) => `course.html.122.p${i+1}`),
                            Array.from({ length: 19 }, (_, i) => `course.html.123.p${i+1}`),
                            Array.from({ length: 19 }, (_, i) => `course.html.131.p${i+1}`),
                            Array.from({ length: 20 }, (_, i) => `course.html.132.p${i+1}`),
                            Array.from({ length: 18 }, (_, i) => `course.html.133.p${i+1}`),
                            Array.from({ length: 16 }, (_, i) => `course.html.141.p${i+1}`),
                            Array.from({ length: 17 }, (_, i) => `course.html.142.p${i+1}`),
                            Array.from({ length: 17 }, (_, i) => `course.html.143.p${i+1}`)
                          ]
  },

  {
    rank: getRankImage(2),
    level: 200,
    title: "INTERMEDIATE",
    description: "Learn advanced layouts, responsive design, and modern CSS techniques.",
    packageDescription: "desc.intermediate",
    contentItems: [ "i.1", "i.2", "i.3", "i.4" ],
    packageFeatures: ["pf.4","pf.5","pf.6"],

    lectures: [
               { group: 0, list: [ "course.html.211.title",
                                   "course.html.212.title",
                                   "course.html.213.title" ]},
               { group: 1, list: [ "course.html.221.title",
                                   "course.html.222.title",
                                   "course.html.223.title"]},
               { group: 2, list: [ "course.html.231.title",
                                   "course.html.232.title",
                                   "course.html.233.title" ]},
               { group: 3, list: [ "course.html.241.title",
                                   "course.html.242.title",
                                   "course.html.243.title" ]}
              ],


    lectureParagraphKeys: [
                            Array.from({ length: 12 }, (_, i) => `course.html.211.p${i+1}`),
                            Array.from({ length: 14 }, (_, i) => `course.html.212.p${i+1}`),
                            Array.from({ length: 13 }, (_, i) => `course.html.213.p${i+1}`),
                            Array.from({ length: 14 }, (_, i) => `course.html.221.p${i+1}`),
                            Array.from({ length: 13 }, (_, i) => `course.html.222.p${i+1}`),
                            Array.from({ length: 13 }, (_, i) => `course.html.223.p${i+1}`),
                            Array.from({ length: 12 }, (_, i) => `course.html.231.p${i+1}`),
                            Array.from({ length: 13 }, (_, i) => `course.html.232.p${i+1}`),
                            Array.from({ length: 11 }, (_, i) => `course.html.233.p${i+1}`),
                            Array.from({ length: 13 }, (_, i) => `course.html.241.p${i+1}`),
                            Array.from({ length: 12 }, (_, i) => `course.html.242.p${i+1}`),
                            Array.from({ length: 13 }, (_, i) => `course.html.243.p${i+1}`)
                          ]
  },

  {
    level: 9999,
    title: "Welcome to the Dashboard",
    description: "Admin panel where user ranks and content can be managed."
  }
  
];
